import clsx from "clsx";

import { type QuickSelectOption } from "@features/metrics-explorer/types";

import { QuickSelectButton } from "../quick-select/quick-select-button";
import { useQuickSelectOptions } from "../quick-select/use-quick-select-options";

interface Props {
  onAddTile: () => void;
  onQuickSelect: (value: QuickSelectOption) => void;
}

export const EmptyState = ({ onAddTile, onQuickSelect }: Props) => {
  const quickSelectOptions = useQuickSelectOptions();

  return (
    <div
      className={clsx(
        "w-full h-[500px] flex items-center justify-center bg-v2-secondary",
        "border border-v2-secondary rounded-lg",
      )}
    >
      <div className="flex flex-col gap-8">
        <div className="flex flex-wrap items-center justify-center gap-2 px-24 max-w-[1200px]">
          {quickSelectOptions.map((option, idx) => {
            return (
              <QuickSelectButton
                key={idx}
                title={option.title}
                onSelect={() => onQuickSelect(option)}
              />
            );
          })}
        </div>
        <div className="flex items-center justify-center">
          <button
            className="flex flex-col items-center gap-3 group"
            onClick={() => onAddTile()}
          >
            <i
              className={clsx(
                "block fa-regular fa-plus text-4xl text-v2-action bg-v2-highlight-information w-[80px] h-[80px]",
                "flex items-center justify-center rounded-full",
                "group-hover:bg-v2-action group-hover:text-white",
              )}
            ></i>
            <span className="font-bold text-lg group-hover:text-v2-action">
              ADD METRIC
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};
